import localStorage from '../utils/localStorage';

const GetSearch = (that) => {
    return that.props.location.search;
}

const GetSearchMembers = (that) => {
    let search = GetSearch(that)
    if (search === '') return []
    
    let searchValues = search.replace('?', '').split('&')
    return searchValues
}

const GetSearchMemberValues = (that) => {
    let searchMember = GetSearchMembers(that)
    let searchMemberValues = []
    searchMember.map(data => {
        let dataSplit = data.split('=');
        let searchMemberValue = {
            key: dataSplit[0],
            val: dataSplit[1]
        };
        
        searchMemberValues.push(searchMemberValue);

        return dataSplit;
    })
    
    return searchMemberValues
}

const GetSearchMenu = (that) => {
    let memberValues = GetSearchMemberValues(that)

    if (memberValues.length === 0) return null

    let memberMenus = memberValues.filter(fi => fi.key.toLowerCase() === 'menu')

    if (memberMenus.length === 0) return null

    if (memberMenus[0].val === undefined) return null

    return memberMenus[0].val
}

const GetSearchSurname = (that) => {
    let memberValues = GetSearchMemberValues(that)

    if (memberValues.length === 0) return null

    let memberSurnames = memberValues.filter(fi => fi.key.toLowerCase() === 'surname')

    if (memberSurnames.length === 0) return null

    if (memberSurnames[0].val === undefined) return null

    return memberSurnames[0].val
}

const GetSearchPushCallback = (that) => {
    let memberValues = GetSearchMemberValues(that)

    if (memberValues.length === 0) return null

    let memberPushCallbacks = memberValues.filter(fi => fi.key.toLowerCase() === 'pushcallback')

    if (memberPushCallbacks.length === 0) return null

    if (memberPushCallbacks[0].val === undefined) return null

    return memberPushCallbacks[0].val
}

const IsSearchMenu = (that) => {
    let searchMenu = GetSearchMenu(that)
    if (searchMenu === null) {
        localStorage.Save('showHeaderFooter', true)
        return false
    }
    if (searchMenu !== '1') {
        localStorage.Save('showHeaderFooter', true)
        return false
    }

    localStorage.Save('showHeaderFooter', false)
    return true 
}

export {
    GetSearch,
    GetSearchMembers,
    GetSearchMemberValues,
    GetSearchMenu,
    GetSearchSurname,
    GetSearchPushCallback,
    IsSearchMenu
}